import React from 'react';

import PropTypes from 'prop-types';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { FlagIcon } from 'apps/auth/components/common/FlagIcon/FlagIcon';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelRightBlock, PanelRow, SelectedDiskBadge } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { getHighlightedText } from 'apps/auth/helpers/utils';

export const CountryItemPanel = ({ showCurrency = true, query = '', countryName, ...props }) => {
    const getPanelRightBlock = () => {
        if (props.isDisabledPanel) {
            return <Icon name={'info-rounded'} color="lightGray" size="16px" />;
        }
        if (props.countryCurrency) {
            return (
                <Text color="secondary" smallCaps>
                    {props.countryCurrency}
                </Text>
            );
        } else if (props.countryPrefix) {
            if (query) {
                return <>{getHighlightedText(query, props.countryPrefix, 'text', { basicColor: 'secondary' })}</>;
            } else {
                return (
                    <Text color="secondary" smallCaps>
                        {props.countryPrefix}
                    </Text>
                );
            }
        }
    };

    return (
        <Panel
            onClick={props.onClick}
            type={props.to ? 'reactLink' : 'link'}
            to={props.to}
            isHoverable
            negativeMargin
            dataTestId={`country-panel-${props.flagIconName}`}
        >
            <PanelRow>
                <PanelRow alignStart whiteSpace={query ? 'pre' : null}>
                    <IconWrapper>
                        {props.getCurrencyIcon ? (
                            <DiskBadge src={props.getCurrencyIcon(props.flagIconName)} alt={props.flagIconName} onError={props.onError} />
                        ) : (
                            <FlagIcon name={props.flagIconName} size="small" isDisabled={props.isDisabledPanel} />
                        )}
                        {props.isSelectedCountry && (
                            <SelectedDiskBadge>
                                <DiskBadge variant="selectedPassive" iconName="check" />
                            </SelectedDiskBadge>
                        )}
                    </IconWrapper>
                    {!!query ? (
                        <>{getHighlightedText(query, countryName, 'text', { basicColor: 'primary' }, false, props.isDisabledPanel)}</>
                    ) : (
                        <Text color={props.isDisabledPanel ? 'lightGray' : 'primary'}>{countryName}</Text>
                    )}
                </PanelRow>
                {showCurrency && <PanelRightBlock flex>{getPanelRightBlock()}</PanelRightBlock>}
            </PanelRow>
        </Panel>
    );
};

CountryItemPanel.propTypes = {
    onClick: PropTypes.func,
    to: PropTypes.string,
    flagIconName: PropTypes.string,
    countryName: PropTypes.string,
    countryCurrency: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    countryPrefix: PropTypes.string,
    isSelectedCountry: PropTypes.bool,
    getCurrencyIcon: PropTypes.func,
};
